import type { TriggerRouter } from "replo-publisher/src/trpc/routers/trigger";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: triggerRouter,
  client: triggerClient,
  utils: triggerUtils,
  options: triggerOptions,
} = createTrpcRouterConfig<TriggerRouter>({
  path: "trigger",
  queryClient: getNamespacedQueryClient("trigger"),
});

export { triggerClient, triggerRouter, triggerUtils, triggerOptions };
